
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"16","height":"16","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('circle',{attrs:{"cx":"8","cy":"8","r":"8","fill":"#FFB93E"}}),_c('path',{attrs:{"d":"M8 4l1.236 2.633L12 7.056l-2 2.05.472 2.894L8 10.633 5.528 12 6 9.106l-2-2.05 2.764-.423L8 4z","fill":"#fff"}})])
          )
        }
      }
    